export const tokens = {
  drawerWidth: 240,
  drawerWidthCollapsed: 72,
  activityPanelWidth: 320,
  topbarHeight: 64,
  borderRadius: 16,
  borderRadiusLarge: 24,
  shadow: {
    soft: '0 1px 2px rgba(16, 24, 40, 0.04), 0 1px 3px rgba(16, 24, 40, 0.06)',
    card: '0 4px 14px rgba(16, 24, 40, 0.04)',
    elevated: '0 10px 32px rgba(16, 24, 40, 0.08)',
  },
  transition: {
    short: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    medium: '250ms cubic-bezier(0.4, 0, 0.2, 1)',
    long: '350ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
} as const
